// src/App.js
import React from 'react';
import IceForm from './ice';

function App() {
  return (
    <div className="App">
      <IceForm />
    </div>
  );
}

export default App;
